<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.id"
        placeholder="ID"
        style="width: 200px"
        class="filter-item"
        size="small"
        clearable
      />
      <el-input
        v-model="listQuery.address"
        placeholder="地址"
        style="width: 200px"
        class="filter-item"
        size="small"
        clearable
      />
      <el-input
        v-model="listQuery.invitation_code"
        placeholder="邀请码"
        style="width: 200px"
        class="filter-item"
        size="small"
        clearable
      />
      <el-select
        v-model="listQuery.is_kol"
        placeholder="是否KOL"
        style="width: 200px"
        class="filter-item"
        size="small"
        clearable
      >
        <el-option label="KOL" :value="1" />
        <el-option label="非KOL" :value="0" />
      </el-select>
      <el-button
        class="filter-item"
        size="small"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        >搜索</el-button
      >
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      size="large"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
    >
      <el-table-column label="ID" width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>

      <el-table-column label="地址" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.address }}
        </template>
      </el-table-column>

      <el-table-column label="邀请码" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.invitation_code }}
        </template>
      </el-table-column>

      <el-table-column label="上线" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.referral }}
        </template>
      </el-table-column>

      <el-table-column label="积分" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.user_account?.account_value }}
        </template>
      </el-table-column>

      <el-table-column label="Twitter" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.user_twitter?.username }}
        </template>
      </el-table-column>

      <el-table-column label="Discord" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.user_discord?.username }}
        </template>
      </el-table-column>

      <el-table-column label="Discord" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.user_telegram?.first_name }} {{ scope.row.user_telegram?.last_name }}
        </template>
      </el-table-column>

      <!-- <el-table-column label="推荐人" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.referral }}
        </template>
      </el-table-column> -->
      
      <el-table-column label="登入IP" min-width="110" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.ip }}</div>
          <div>{{ scope.row.ipAddress || "" }}</div>
        </template>
      </el-table-column>

      <el-table-column label="最后登入时间" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.last_login_at | dateTimeFormat }}
        </template>
      </el-table-column>

      <el-table-column label="加入时间" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_at | dateTimeFormat }}
        </template>
      </el-table-column>

      <el-table-column label="KOL" min-width="100" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.is_kol === 1 ? 'success' : 'info'" size="mini">
            {{ scope.row.is_kol === 1 ? "是" : "否" }}
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column label="操作" min-width="150" align="center">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.is_kol !== 1"
            size="mini"
            type="primary"
            :loading="kolUpdatingId === scope.row.id"
            @click="updateKolStatus(scope.row, 1)"
          >
            设为KOL
          </el-button>
          <el-button
            v-else
            size="mini"
            type="warning"
            :loading="kolUpdatingId === scope.row.id"
            @click="updateKolStatus(scope.row, 0)"
          >
            取消KOL
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        is_kol: null,
      },
      dialogFormVisible: false,
      btnLoading: false,
      kolUpdatingId: null,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.listLoading = true;
      const params = {...this.listQuery};
      if (params.is_kol === null || params.is_kol === '' || params.is_kol === undefined) {
        delete params.is_kol;
      }
      request({
        url: "/api/admin/user/list",
        method: "get",
        params,
      }).then((response) => {
        this.list = response.data.data
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    async updateKolStatus(row, isKol) {
      const actionText = isKol === 1 ? "设为KOL" : "取消KOL";
      try {
        await this.$confirm(`确认${actionText}该用户？`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
      } catch (error) {
        return;
      }

      this.kolUpdatingId = row.id;
      try {
        await request({
          url: "/api/admin/user/kol-status",
          method: "post",
          data: {
            user_id: row.id,
            is_kol: isKol,
          },
        });
        this.$message.success(`${actionText}成功`);
        this.getList();
      } catch (error) {
        // 错误提示由统一请求拦截器处理
      } finally {
        this.kolUpdatingId = null;
      }
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}
.balance {
  font-size: 18px;
  font-weight: bold;
}
</style>
